export const labels = {
  title: {
    term: 'SignUp.PlandaySignupTitle',
    fallback: 'Start your 30-day free trial',
  },
  accountStepTitle: {
    term: 'SignUp.FirstStepTitle',
    fallback: 'Create your Planday account',
  },
  descriptionPoint1: {
    term: 'SignUp.Step1_ValueStatement1',
    fallback: 'Get started instantly—no commitment, no credit card!',
  },
  descriptionPoint2: {
    term: 'SignUp.Step1_ValueStatement2',
    fallback: 'Explore all of Planday’s features at no cost.',
  },
  businessStepTitle: {
    term: 'SignUp.SecondStepTitle',
    fallback: 'Tell us about your business',
  },
  businessStepSubtitle: {
    term: 'SignUp.SecondStepSubtitle',
    fallback:
      'With a few details, we can start shaping Planday for your business.',
  },
  teamStepTitle: {
    term: 'XXX',
    fallback: `Let's meet your team`,
  },
  teamStepSubtitle: {
    term: 'XXX',
    fallback:
      'Help us get to know your team, so we can get you off to a good start. You can adjust it later.',
  },
  teamStepNextButtonLabel: {
    term: 'XXX',
    fallback: 'Build my first schedule',
  },
  headerDescription: {
    term: 'SignUp.HeaderDescription',
    fallback: 'Signup for a 30 day trial with planday',
  },
  firstName: {
    term: 'CommonTerms.Firstname',
    fallback: 'First name',
  },
  lastName: {
    term: 'CommonTerms.Lastname',
    fallback: 'Last name',
  },
  email: {
    term: 'CommonTerms.Email',
    fallback: 'Email',
  },
  emailSuggestion: {
    term: 'SignUp.EmailSuggestion',
    fallback:
      'We suggest you use your business email, as you’ll use this to log into your account.',
  },
  phoneNumber: {
    term: 'SignUp.PhoneNumber',
    fallback: 'Phone number',
  },
  password: {
    term: 'CommonTerms.Password',
    fallback: 'Password',
  },
  termsAndConditions: {
    term: 'SignUp.LegalPolicies_Consent',
    fallback:
      'By clicking Agree and Continue, you confirm that you have read and accept our {0}, {1}, {2} and the {3} and consent to receiving sales communications via phone, email, or the Planday App during your 30-day trial. You can unsubscribe at any time.',
  },
  next: {
    term: 'CommonTerms.Next',
    fallback: 'Next',
  },
  accountStepCTA: {
    term: 'SignUp.FirstStepCTA',
    fallback: 'Agree and continue',
  },
  dataProcessing: {
    term: 'SignUp.DataProcessing',
    fallback: 'Data Processing Agreement',
  },
  dataProccesingLinks: {
    term: 'SignUp.DataProcessingLinks',
    fallback:
      'https://brandfolder.xero.com/YP89N00Y/as/np4txjj74hwmt5x83mz989c/Data_Processing_Agreement_EN',
  },
  privacyPolicy: {
    term: 'SignUp.PrivacyPolicy',
    fallback: 'Privacy Policy',
  },
  privacyPolicyLinks: {
    term: 'SignUp.PrivacyPolicyLinks',
    fallback:
      'https://brandfolder.xero.com/YP89N00Y/as/g8kfwh9hfp44vfjmjn83389m/Privacy_Policy_UK',
  },
  trialTerms: {
    term: 'SignUp.TrialTerms',
    fallback: 'Trial Terms',
  },
  trialTermsLinks: {
    term: 'SignUp.TrialTermsLinks',
    fallback:
      'https://brandfolder.xero.com/YP89N00Y/as/84jhgn586phqtgm9csn5vs58/Trial_Terms_2023_UK',
  },
  generalTerms: {
    term: 'SignUp.GeneralTerms',
    fallback: 'General Terms',
  },
  generalTermsLinks: {
    term: 'SignUp.GeneralTermsLinks',
    fallback:
      'https://brandfolder.xero.com/YP89N00Y/as/96qr2txfr32qbv25853m9xkt/General_Subscription_Terms_and_Conditions_UK',
  },
  marketingCommunications: {
    term: 'SignUp.MarketingConsent',
    fallback:
      'By checking this box, you agree to receive newsletters, offers and updates about Planday products and services via email, phone, or the Planday app after your trial period. You can unsubscribe at any time.',
  },
  marketingCommunicationDuringTrial: {
    term: 'SignUp.MarketingCommunicationDuringTrial',
    fallback:
      'By starting a free trial of Planday, you consent to receiving sales communications via phone, mail or the Planday App during your 30 day trial. You can unsubscribe at any time.',
  },
  stepperAccountStep: {
    term: 'SignUp.Stepper_YourAccount',
    fallback: 'Your account',
  },
  stepperBusinessStep: {
    term: 'SignUp.Stepper_YourBusiness',
    fallback: 'Your business',
  },
  stepperTeamStep: {term: 'SignUp.Stepper_YourTeam', fallback: 'Your team'},

  loadingErrorCTA: {
    term: 'SignUp.LoadingErrorCTA',
    fallback: 'Go to step 1',
  },
  portalLanguage: {
    term: 'SignUp.Label_PortalLanguage',
    fallback: 'Language',
  },
  portalLanguageHelpText: {
    term: 'SignUp.LanguageSelection_HelpText',
    fallback: 'This will be your user language. You can adjust it later.',
  },
};

export const businessLabels = {
  title: {
    term: 'SignUp.BusinessFormTitle',
    fallback: 'Tell us about your business',
  },
  subTitle: {
    term: 'SignUp.BusinessFormSubTitle',
    fallback:
      'With a few details, we can start shaping Planday for your business.',
  },
  businessName: {
    term: 'SignUp.BusinessName',
    fallback: 'What’s your business called?',
  },
  businessNameHelpText: {
    term: 'SignUp.BusinessNameHelpText',
    fallback: 'Your business’s login link will appear here.',
  },
  businessLocation: {
    term: 'SignUp.BusinessLocation',
    fallback: 'Where is your business located?',
  },
  businessLocationHelpText: {
    term: 'SignUp.BusinessLocationHelpText',
    fallback:
      'We’ll use this for country specific setup (e.g. currency, date & time format, etc.).',
  },
  businessType: {
    term: 'SignUp.BusinessType',
    fallback: 'What type of business is it?',
  },
  businessTypeHelpText: {
    term: 'SignUp.BusinessTypeHelpText',
    fallback:
      'This will help us fine-tune your experience to suit your business.',
  },
  employeesNumber: {
    term: 'SignUp.BusinessEmployeesNumber',
    fallback: 'How many employees do you have?',
  },
  previous: {
    term: 'CommonTerms.Previous',
    fallback: 'Previous',
  },
};

export const teamLabels = {
  addEmployee: {term: 'XXX', fallback: 'Add employee'},
  addRole: {term: 'XXX', fallback: 'Add role'},
};

export const industryTranslations = {
  hospitality: {
    hospitality: {
      term: 'SignUp.Industry_Hospitality',
      fallback: 'Hospitality',
    },
    hotels: {
      term: 'SignUp.Industry_Hotels',
      fallback: 'Hotels',
    },
    cafeRestaurant: {
      term: 'SignUp.Industry_CafeRestaurant',
      fallback: 'Café & Restaurant',
    },
    barPubNightclub: {
      term: 'SignUp.Industry_BarPubNightclub',
      fallback: 'Bar, Pub & Nightclub',
    },
    cateringCanteen: {
      term: 'SignUp.Industry_CateringCanteen',
      fallback: 'Catering & Canteen',
    },
  },
  retail: {
    retail: {
      term: 'SignUp.Industry_Retail',
      fallback: 'Retail',
    },
    retailStore: {
      term: 'SignUp.Industry_RetailStore',
      fallback: 'Retail Store',
    },
    bakery: {
      term: 'SignUp.Industry_Bakery',
      fallback: 'Bakery',
    },
    barberShopsBeautySalons: {
      term: 'SignUp.Industry_BarberShopsBeautySalons',
      fallback: 'Barber Shops & Beauty Salons',
    },
  },
  professionalServices: {
    professionalServices: {
      term: 'SignUp.Industry_ProfessionalServices',
      fallback: 'Professional Services',
    },
    realEstate: {
      term: 'SignUp.Industry_RealEstate',
      fallback: 'Real Estate',
    },
    cleaningServices: {
      term: 'SignUp.Industry_CleaningServices',
      fallback: 'Cleaning Services',
    },
    security: {
      term: 'SignUp.Industry_Security',
      fallback: 'Security',
    },
    staffingAndRecruiting: {
      term: 'SignUp.Industry_StaffingAndRecruiting',
      fallback: 'Staffing and Recruiting',
    },
    callCenterTelemarketing: {
      term: 'SignUp.Industry_CallCenterTelemarketing',
      fallback: 'Call Center & Telemarketing',
    },
    facilitiesManagementCommercialCleaning: {
      term: 'SignUp.Industry_FacilitiesManagementCommercialCleaning',
      fallback: 'Facilities Management & Commercial Cleaning',
    },
  },
  entertainmentLeisure: {
    entertainmentLeisure: {
      term: 'SignUp.Industry_EntertainmentLeisure',
      fallback: 'Entertainment & Leisure',
    },
    entertainmentCinemasFunParks: {
      term: 'SignUp.Industry_EntertainmentCinemasFunParks',
      fallback: 'Entertainment, Cinemas & Fun Parks',
    },
    eventsEventManagement: {
      term: 'SignUp.Industry_EventsEventManagement',
      fallback: 'Events & Event Management',
    },
    museumsAndInstitutions: {
      term: 'SignUp.Industry_MuseumsAndInstitutions',
      fallback: 'Museums and Institutions',
    },
    performingArts: {
      term: 'SignUp.Industry_PerformingArts',
      fallback: 'Performing Arts',
    },
  },
  healthcareMedical: {
    healthcareMedical: {
      term: 'SignUp.Industry_HealthcareMedical',
      fallback: 'Healthcare & Medical',
    },
    elderlyCareServices: {
      term: 'SignUp.Industry_ElderlyCareServices',
      fallback: 'Elderly Care Services',
    },
    dentalOffices: {
      term: 'SignUp.Industry_DentalOffices',
      fallback: 'Dental Offices',
    },
    hospitalsClinics: {
      term: 'SignUp.Industry_HospitalsClinics',
      fallback: 'Hospitals & Clinics',
    },
    drugStoresPharmacies: {
      term: 'SignUp.Industry_DrugStoresPharmacies',
      fallback: 'Drug Stores & Pharmacies',
    },
    veterinaryServices: {
      term: 'SignUp.Industry_VeterinaryServices',
      fallback: 'Veterinary Services',
    },
  },
  wellnessFitness: {
    wellnessFitness: {
      term: 'SignUp.Industry_WellnessFitness',
      fallback: 'Wellness & Fitness',
    },
    fitnessDanceFacilities: {
      term: 'SignUp.Industry_FitnessDanceFacilities',
      fallback: 'Fitness & Dance Facilities',
    },
    sports: {
      term: 'SignUp.Industry_Sports',
      fallback: 'Sports',
    },
  },
  education: {
    education: {
      term: 'SignUp.Industry_Education',
      fallback: 'Education',
    },
    collegesUniversities: {
      term: 'SignUp.Industry_CollegesUniversities',
      fallback: 'Colleges & Universities',
    },
    primarySecondaryEducation: {
      term: 'SignUp.Industry_PrimarySecondaryEducation',
      fallback: 'Primary or Secondary Education',
    },
    childcare: {
      term: 'SignUp.Industry_Childcare',
      fallback: 'Childcare',
    },
  },
  finance: {
    finance: {
      term: 'SignUp.Industry_Finance',
      fallback: 'Finance',
    },
    accounting: {
      term: 'SignUp.Industry_Accounting',
      fallback: 'Accounting',
    },
    insurance: {
      term: 'SignUp.Industry_Insurance',
      fallback: 'Insurance',
    },
    banking: {
      term: 'SignUp.Industry_Banking',
      fallback: 'Banking',
    },
  },
  mediaCommunications: {
    mediaCommunications: {
      term: 'SignUp.Industry_MediaCommunications',
      fallback: 'Media & Communications',
    },
    advertising: {
      term: 'SignUp.Industry_Advertising',
      fallback: 'Advertising',
    },
    media: {
      term: 'SignUp.Industry_Media',
      fallback: 'Media',
    },
    press: {
      term: 'SignUp.Industry_Press',
      fallback: 'Press',
    },
  },
  transportation: {
    transportation: {
      term: 'SignUp.Industry_Transportation',
      fallback: 'Transportation',
    },
    logisticsAndSupplyChain: {
      term: 'SignUp.Industry_LogisticsAndSupplyChain',
      fallback: 'Logistics & Supply Chain',
    },
    warehousing: {
      term: 'SignUp.Industry_Warehousing',
      fallback: 'Warehousing',
    },
  },
  softwareITServices: {
    softwareITServices: {
      term: 'SignUp.Industry_SoftwareITServices',
      fallback: 'Software & IT Services',
    },
    software: {
      term: 'SignUp.Industry_Software',
      fallback: 'Software',
    },
  },
  other: {
    other: {
      term: 'SignUp.Industry_Other',
      fallback: 'Other',
    },
    construction: {
      term: 'SignUp.Industry_Construction',
      fallback: 'Construction',
    },
    manufacturing: {
      term: 'SignUp.Industry_Manufacturing',
      fallback: 'Manufacturing',
    },
    municipality: {
      term: 'SignUp.Industry_Municipality',
      fallback: 'Municipality',
    },
    nonProfitCharitableOrganizations: {
      term: 'SignUp.Industry_NonProfitCharitableOrganizations',
      fallback: 'Non-Profit & Charitable Organizations',
    },
  },
};

export const signupScreenLabels = {
  title: {
    term: 'SignUp.SignUpScreenTitle',
    fallback: 'Please wait while we set up your trial',
  },
};

export const validationLabels = {
  email: {
    invalid: {
      term: 'SignUp.Validation_EmailInvalid',
      fallback: 'Invalid email',
    },
    inUse: {
      term: 'SignUp.Validation_EmailInUse',
      fallback: 'Email already in use',
    },
  },
  password: {
    term: 'SignUp.Validation_Password',
    fallback: 'Password must be at least 8 characters',
  },
  phone: {
    term: 'SignUp.Validation_Phone',
    fallback: 'Invalid phone number',
  },
  companyName: {
    term: 'SignUp.Validation_CompanyName',
    fallback: 'Company name is not available',
  },
};

export const errorMessages = {
  generic: {
    term: 'CommonTerms.GenericErrorMessage',
    fallback: 'An error occurred. Please try again.',
  },
  required: {
    term: 'CommonTerms.Generic_RequiredField',
    fallback: 'Required Field',
  },
  LoadingError: {
    term: 'SignUp.LoadingError',
    fallback:
      'Sorry, something went wrong when we tried creating your account. Please try to sign up again.',
  },
};
